<div
	class="home-page-container"
	[ngClass]="{ hideMainCol: hideMainCol === true }"
	*ngIf="!isLoadingAvailableAccordions && labels && !isLoadingAllStatus">
	<div
		[ngStyle]="{
			width: hideMainCol === true ? null : ghostResizeBar.mainCol + '%',
			'user-select': dragAccordion.isDragging ? 'none' : 'unset',
		}"
		class="accordion-col"
		[ngClass]="{ 'main-col': secondColView === 'not-chosen' && hideMainCol === false }"
		(scroll)="dragAccordion.dragScreenScrollTop = accordionCol.scrollTop"
		#accordionCol>
		<div class="accordion-options-container">
			@if (profileSignal.requestUpdateIntervalOn() === true) {
				<div class="update-counter-container" [appTooltip]="'Tempo até próxima atualização'" (click)="setupAccordionTimer()">
					<div class="update-counter" [style.--percentage]="accordionRemainingUpdatePercentage + '%'"></div>
				</div>
			}
			<span class="option-button" (click)="saveAccordionOptions(); rollAccordionOptionTransition()"
				><fa-icon [icon]="isEditingAccordionOptions === false ? icons.faGear : icons.faCheck"></fa-icon
			></span>
		</div>
		<button tabindex="-1" class="button" [disabled]="isEditingAccordionOptions === true" (click)="resetRequestOpening()">
			{{ labels.lbl_chamado_abrir }}
		</button>
		<button tabindex="-1" class="button" [disabled]="isEditingAccordionOptions === true" (click)="toogleDivCustom()">
			{{ labels.lbl_kb_criar }} {{ labels.lbl_rep_custom_id_32 }}
		</button>

		<ng-container *ngFor="let accordionGroup of accordionOrder; let groupIndex = index">
			<div
				class="accordion-container"
				[ngClass]="{
					'drag-source':
						isEditingAccordionOptions && dragAccordion.draggingType === 'group' && dragAccordion.groupIndex === groupIndex,
					hidden: accordionGroup.hidden === true,
				}"
				*ngIf="accordionGroup.accordionArr?.length > 0 && (accordionGroup.hidden !== true || isEditingAccordionOptions)">
				<div class="title">
					<span
						(mousedown)="isEditingAccordionOptions ? startDragAccordion(accordionCol, $event, 'group', groupIndex) : null"
						*ngIf="isEditingAccordionOptions"
						><fa-icon [icon]="icons.faGripVertical"></fa-icon
					></span>
					<span
						class="to-hide-button"
						(click)="accordionGroup.hidden = !accordionGroup.hidden; endDragAccordion()"
						*ngIf="isEditingAccordionOptions"
						><fa-icon [icon]="accordionGroup.hidden === true ? icons.faSquare : icons.faSquareCheck"></fa-icon
					></span>
					<span (mousedown)="isEditingAccordionOptions ? startDragAccordion(accordionCol, $event, 'group', groupIndex) : null">{{
						labels[accordionGroup.label] ? labels[accordionGroup.label] : accordionGroup.label
					}}</span>
					<fa-icon
						[icon]="icons.faInfoCircle"
						[title]="labels[accordionGroup.tip] ? labels[accordionGroup.tip] : accordionGroup.tip"
						*ngIf="accordionGroup.tip"></fa-icon>
				</div>
				@for (accordion of accordionGroup.accordionArr; let accordionIndex = $index; track accordion) {
					<div
						class="accordion-button"
						[ngClass]="{
							'border-alert': accordionGroup.accordionArr.accordionLength > 0 && accordionGroup.accordionArr.alert,
							'drag-source':
								isEditingAccordionOptions &&
								dragAccordion.draggingType === 'accordion' &&
								dragAccordion.groupIndex === groupIndex &&
								dragAccordion.accordionIndex === accordionIndex,
							hidden: accordion.hidden === true,
						}"
						[ngStyle]="{
							'border-color':
								accordionGroup.accordionArr.accordionLength > 0 && accordionGroup.accordionArr.alert
									? 'var(--danger)'
									: accordionGroup.accordionArr.border,
						}"
						(mousedown)="
							isEditingAccordionOptions
								? startDragAccordion(accordionCol, $event, 'accordion', groupIndex, accordionIndex)
								: null
						"
						(click)="
							accordion.type === 'group'
								? (accordionSolutionArea = accordion.id?.toString())
								: (accordionSolutionArea = null);
							getColumnHeaders(accordion.id);
							getSelectedAccordionData(accordion, 1)
						"
						*ngIf="accordion.hidden !== true || isEditingAccordionOptions">
						<div>
							<span *ngIf="isEditingAccordionOptions"><fa-icon [icon]="icons.faGripVertical"></fa-icon></span>
							<span
								class="to-hide-button"
								(click)="accordion.hidden = !accordion.hidden; endDragAccordion()"
								*ngIf="isEditingAccordionOptions"
								><fa-icon [icon]="accordion.hidden === true ? icons.faSquare : icons.faSquareCheck"></fa-icon
							></span>
							<span>{{ accordion.name }}</span>
						</div>
						<div class="accordion-pill-container">
							<div class="accordion-length-pill">
								<span>
									@if (isLoadingAccordionLength.includes(accordionGroup.id)) {
										<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
									} @else {
										{{
											accordion.accordionLength <= 9
												? '00' + accordion.accordionLength
												: accordion.accordionLength <= 99
													? '0' + accordion.accordionLength
													: accordion.accordionLength
										}}
									}
								</span>
							</div>
						</div>
						<div
							class="drop-option"
							(mouseenter)="dragAccordion.dropIndex = accordionIndex"
							(mousemove)="setDragPosition(accordionCol, $event)"
							(mouseup)="dropAccordion(groupIndex, accordionIndex)"
							*ngIf="
								dragAccordion.isDragging &&
								dragAccordion.draggingType === 'accordion' &&
								dragAccordion.groupIndex === groupIndex
							"></div>
					</div>
				}
				<div
					class="drag-screen"
					(mousemove)="setDragPosition(accordionCol, $event)"
					(mouseup)="endDragAccordion()"
					*ngIf="
						dragAccordion.isDragging && dragAccordion.draggingType === 'accordion' && dragAccordion.groupIndex === groupIndex
					"></div>
				<div
					class="drop-option"
					(mouseenter)="dragAccordion.dropIndex = groupIndex"
					(mousemove)="setDragPosition(accordionCol, $event)"
					(mouseup)="dropAccordion(groupIndex)"
					*ngIf="dragAccordion.isDragging && dragAccordion.draggingType === 'group'"></div>
			</div>
		</ng-container>

		<div
			class="drag-screen"
			[ngStyle]="{ 'top.px': dragAccordion.dragScreenScrollTop }"
			(mousemove)="setDragPosition(accordionCol, $event)"
			(mouseup)="endDragAccordion()"
			*ngIf="dragAccordion.isDragging && dragAccordion.draggingType === 'group'"></div>
		<div
			class="drag-holding-item"
			[ngStyle]="{ 'left.px': dragAccordion.position.x, 'top.px': dragAccordion.position.y }"
			*ngIf="dragAccordion.isDragging">
			{{ dragAccordion.dragName }}
		</div>
		<div class="oneColView right" (click)="toggleMainCol()" *ngIf="hideMainCol === true && secondColView === 'not-chosen'">
			<fa-icon [icon]="icons.faMattressPillow"></fa-icon>
		</div>
	</div>
	<div
		class="accordion-options-container-transition"
		[ngStyle]="{ width: hideMainCol === true ? null : ghostResizeBar.mainCol + '%' }"
		*ngIf="editingAccordionTransition"></div>

	<div
		[ngStyle]="{ width: hideMainCol === true ? null : ghostResizeBar.subCol + '%' }"
		class="not-chosen-rmk"
		*ngIf="secondColView === 'not-chosen' || secondColView === 'loading'">
		<div class="oneColView left" (click)="toggleMainCol()"><fa-icon [icon]="icons.faMattressPillow"></fa-icon></div>

		<div class="header" style="display: flex; justify-content: space-between; align-items: center; gap: 4px">
			<nav class="navigation">
				<a (click)="secondColView = 'not-chosen'">< {{ labels.lbl_geral_inicio }} </a>
			</nav>

			<ng-container *ngTemplateOutlet="searchTpl"></ng-container>
		</div>

		<div
			class="centered-content"
			style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%">
			<cpi-svg-gears [gearSpinDurationMS]="10000"></cpi-svg-gears>
			<div>
				{{ secondColView === 'not-chosen' ? labels.lbl_selecione_uma_opcao : labels.lbl_edocs_carregando }}
			</div>
			<div class="ghost-resize-bar" (mousedown)="ghostResizeBar.mouseDown = true" *ngIf="!hideMainCol"></div>
		</div>
	</div>

	<div
		[ngStyle]="{ width: hideMainCol === true ? null : ghostResizeBar.subCol + '%' }"
		class="card-col"
		*ngIf="secondColView === 'card-col'">
		<div class="oneColView left" (click)="toggleMainCol()"><fa-icon [icon]="icons.faMattressPillow"></fa-icon></div>

		<div class="header" style="display: flex; justify-content: space-between; align-items: center; gap: 4px">
			<nav class="navigation">
				<a (click)="secondColView = 'not-chosen'">< {{ labels.lbl_geral_inicio }} </a>
				<a [routerLink]="'/cmdb/list'">< {{ selectedAccordion.name }} </a>
			</nav>

			<ng-container *ngTemplateOutlet="searchTpl"></ng-container>

			<div class="button-container" *ngIf="selectedAccordion.type !== 'task' && !selectedAccordion.taskGroupExecution">
				<button (click)="viewColumnModal.openModal()">{{ labels.lbl_geral_opcoes_de_coluna }}</button>
			</div>
		</div>

		<ng-container *ngIf="selectedAccordion.accordionLength > 0">
			<div class="request-table-container">
				<!-- <div
					class="msp-table-container"
					[ngClass]="{ lock: isLoadingAccordionData }"
					[ngStyle]="{
						'grid-template-columns': 'repeat(' + requestViewItemsOptions[0].values.length + 2 + ', 1fr) min-content',
						'grid-template-rows': 'repeat(' + itemsPerPage + ', 1fr)',
					}"
					id="mspTableContainer">
					<div
						class="table-line header"
						[ngStyle]="{ 'grid-column-end': requestViewItemsOptions[0].values.length + 2 }"
						#tableLineHeader>

						<div *ngFor="let header of requestViewItemsOptions[0].values; let index = index">
							<div class="header-title">
								<div>{{ labels[header.label] ? labels[header.label] : header.label }}</div>
								<div (click)="sortColumn(header.name); getSelectedAccordionData(selectedAccordion, selectedPage)">
									<fa-icon [icon]="sortBy !== header.name || sortDown ? icons.faSortDown : icons.faSortUp"></fa-icon>
								</div>
							</div>
						</div>
						<div>
							<span>{{ labels.lbl_bulletin_actions }}</span>
						</div>
					</div>

					<a
						[href]="'request/' + ci.id"
						class="table-line"
						[ngStyle]="{ 'grid-column-end': requestViewItemsOptions[0].values.length + 2 }"
						*ngFor="let ci of selectedAccordion[selectedAccordion.dataType]; let index = index">

						<div
							[title]="handleCellValue(ci[header.name], header.inputType)"
							[ngStyle]="handleCellMarkup(ci[header.name])"
							[ngClass]="{ marquee: isElementOverflown(cellElement) }"
							#cellElement
							*ngFor="let header of requestViewItemsOptions[0].values">
							<span>
								{{ handleCellValue(ci[header.name], header.inputType) }}
							</span>
						</div>

						<div class="action-cell">
							<span><fa-icon [icon]="icons.faEye"></fa-icon></span>
						</div>
					</a>

					<div class="fog-container" *ngIf="isLoadingAccordionData">
						<div class="loading-container">
							<cpi-svg-gears></cpi-svg-gears>
							<div>{{ labels.lbl_edocs_carregando }}!</div>
						</div>
					</div>
				</div> -->

				<msp-table-rmk
					*ngIf="selectedAccordion.type === 'task' || selectedAccordion.taskGroupExecution"
					[headers]="taskExecutionHeaders"
					[data]="selectedAccordion[selectedAccordion.dataType]"
					[enableSorting]="true"
					[onLineRouterLink]="'/request/:id'"
					[flattenLineLinks]="true"
					[sort]="{ sortBy: sortBy, sortOrder: sortDown ? 'desc' : 'asc', sortDown: sortDown }"
					(getSort)="
						sortBy = $event.sortBy; sortDown = $event.sortDown; getSelectedAccordionData(selectedAccordion, selectedPage)
					"
					[isLoading]="isLoadingAccordionData">
				</msp-table-rmk>

				<msp-table-rmk
					*ngIf="selectedAccordion.type !== 'task' && !selectedAccordion.taskGroupExecution"
					[headers]="requestViewHeaders()"
					[data]="selectedAccordion[selectedAccordion.dataType]"
					[enableSorting]="true"
					[enableExport]="true"
					[onLineRouterLink]="'/request/:id'"
					[sort]="{ sortBy: sortBy, sortOrder: sortDown ? 'desc' : 'asc', sortDown: sortDown }"
					(getSort)="
						sortBy = $event.sortBy; sortDown = $event.sortDown; getSelectedAccordionData(selectedAccordion, selectedPage)
					"
					(exportTable)="exportRequestModal.openModal()"
					[isLoading]="isLoadingAccordionData">
				</msp-table-rmk>
			</div>
			<cpi-pagination-counter
				[arrayLength]="selectedAccordion.accordionLength"
				[itemsPerPage]="itemsPerPage"
				[setCurrentPage]="selectedPage"
				(getCurrentPage)="getSelectedAccordionData(selectedAccordion, $event)">
			</cpi-pagination-counter>
		</ng-container>

		<div class="ghost-resize-bar" (mousedown)="ghostResizeBar.mouseDown = true" *ngIf="!hideMainCol"></div>
	</div>

	<div
		[ngStyle]="{ width: hideMainCol === true ? null : ghostResizeBar.subCol + '%' }"
		class="selfservice-col"
		*ngIf="secondColView === 'selfservice'">
		<div class="oneColView left" (click)="toggleMainCol()"><fa-icon [icon]="icons.faMattressPillow"></fa-icon></div>
		<!-- <ng-container *ngTemplateOutlet="searchTpl"></ng-container> -->
		<pcp-selfservice-page (leavePage)="secondColView = 'not-chosen'" (newRequestCreated)="getAllAccordion()"></pcp-selfservice-page>
		<div class="ghost-resize-bar" (mousedown)="ghostResizeBar.mouseDown = true" *ngIf="!hideMainCol"></div>
	</div>

	<div
		[ngStyle]="{ width: hideMainCol === true ? null : ghostResizeBar.subCol + '%' }"
		class="satisfaction-col"
		*ngIf="secondColView === 'satisfaction'">
		<div class="oneColView left" (click)="toggleMainCol()"><fa-icon [icon]="icons.faMattressPillow"></fa-icon></div>
		<ng-container *ngTemplateOutlet="searchTpl"></ng-container>
		<pcp-request-satisfaction
			(leavePage)="secondColView = 'not-chosen'; getAllAccordion()"
			[listName]="selectedAccordion.name"
			[requestId]="satisfactionId"></pcp-request-satisfaction>
		<div class="ghost-resize-bar" (mousedown)="ghostResizeBar.mouseDown = true" *ngIf="!hideMainCol"></div>
	</div>

	<div [ngStyle]="{ width: hideMainCol === true ? null : ghostResizeBar.subCol + '%' }" class="kb-col" *ngIf="secondColView === 'kb'">
		<div class="oneColView left" (click)="toggleMainCol()"><fa-icon [icon]="icons.faMattressPillow"></fa-icon></div>
		<ng-container *ngTemplateOutlet="searchTpl"></ng-container>

		<pcp-knowledge-archive (leavePage)="secondColView = 'not-chosen'"></pcp-knowledge-archive>
		<div class="ghost-resize-bar" (mousedown)="ghostResizeBar.mouseDown = true" *ngIf="!hideMainCol"></div>
	</div>

	<div
		[ngStyle]="{ width: hideMainCol === true ? null : ghostResizeBar.subCol + '%' }"
		class="custom-col"
		*ngIf="secondColView === 'custom' && showForm === true">
		<!-- <ng-container *ngTemplateOutlet="searchTpl"></ng-container> -->
		<div class="home-form-container">
			<register-form-custom-accordion></register-form-custom-accordion>
		</div>
	</div>

	<div
		[ngStyle]="{ width: hideMainCol === true ? null : ghostResizeBar.subCol + '%' }"
		class="search-col"
		*ngIf="secondColView === 'search-col'">
		<div class="oneColView left" (click)="toggleMainCol()"><fa-icon [icon]="icons.faMattressPillow"></fa-icon></div>

		<div class="header" style="display: flex; justify-content: space-between; align-items: center; gap: 4px">
			<nav class="navigation">
				<a (click)="secondColView = 'not-chosen'">< {{ labels.lbl_geral_inicio }} </a>
				<a [routerLink]="'/request'">< {{ labels.lbl_geral_pesquisa_chamados }} </a>
			</nav>

			<ng-container *ngTemplateOutlet="searchTpl"></ng-container>
		</div>

		<div class="request-table-container">
			<div class="msp-table-container">
				<div class="table-line header" *ngIf="searchRequestsList.length > 0">
					<div *ngFor="let header of searchHeaderRequest; let index = index">
						<div class="header-title">
							<div>{{ labels[header.value] ? labels[header.value] : header.value }}</div>
						</div>
					</div>
					<div>
						<span>{{ labels.lbl_bulletin_actions }}</span>
					</div>
				</div>

				<ng-container *ngIf="isLoadingSearch">
					<div class="fog-container">
						<div class="loading-container">
							<cpi-svg-gears></cpi-svg-gears>
							<div>
								{{ searchRequestsList.length > 0 ? labels.lbl_edocs_carregando : labels.lbl_selecione_uma_opcao }}
							</div>
						</div>
					</div>
				</ng-container>

				<ng-container *ngIf="!isLoadingSearch">
					<div class="table-line" *ngFor="let item of searchRequestsList; let index = index">
						<div
							[title]="handleCellValue(item[header.name], header.inputType)"
							[ngStyle]="handleCellMarkup(item[header.name])"
							[ngClass]="{ marquee: isElementOverflown(cellElement) }"
							#cellElement
							*ngFor="let header of searchHeaderRequest"
							(click)="openRequest(item)"
							style="cursor: pointer">
							<span>
								{{ handleCellValue(item[header.name], header.inputType) }}
							</span>
						</div>

						<div class="action-cell">
							<a [href]="'request/' + item.id"><fa-icon [icon]="icons.faEye"></fa-icon></a>
						</div>
					</div>
				</ng-container>
			</div>

			<cpi-pagination-counter
				*ngIf="searchRequestsList.length > 0"
				[arrayLength]="totalLengthSearch"
				[itemsPerPage]="itemsPerPage"
				[setCurrentPage]="selectedPageSearch"
				(getCurrentPage)="onPageChange($event)">
			</cpi-pagination-counter>
		</div>
	</div>

	<div
		class="ghost-screen"
		(mouseup)="ghostResizeBar.mouseDown = false"
		(mousemove)="handleGhostResizeBar($event)"
		*ngIf="ghostResizeBar.mouseDown"></div>
</div>

<cpi-modal [title]="labels.lbl_geral_opcoes_de_coluna" [showFooter]="true" #viewColumnModal>
	<ng-container body>
		<cpi-generic-form-gen [setGenericForm]="requestViewItemsOptions" [labels]="labels"> </cpi-generic-form-gen>
	</ng-container>
	<ng-container footer>
		<div class="button-container">
			<button [ngClass]="{ disabled: isSavingRequestViewColumn }" (click)="saveRequestViewColumns()">
				{{ labels.lbl_geral_salvar }}
				<cpi-dot-bounce-loading-effect *ngIf="isSavingRequestViewColumn"></cpi-dot-bounce-loading-effect>
			</button>
		</div>
	</ng-container>
</cpi-modal>

<cpi-modal [title]="labels.lbl_extracao_geral" [showFooter]="true" #exportRequestModal>
	<ng-container body>
		<span>{{ labels.lbl_essa_extracao_pode_levar_segundos.replace('§_seconds_§', '60') }}</span>
	</ng-container>
	<ng-container footer>
		<div class="button-container">
			<div class="button" (click)="exportRequestTable()">{{ labels.lbl_geral_exportar }}</div>
		</div>
	</ng-container>
</cpi-modal>

<ng-template #searchTpl>
	<div class="accordion">
		<div class="accordion-content-items">
			<cpi-input-with-autocomplete
				class="main-input-field-container"
				[availableOptions]="filteredOptionsIAC"
				[placeholder]="labels.lbl_geral_pesquisa"
				[minInputLength]="0"
				[inputHeight]="'21px'"
				(onValueChange)="selectOption($event)"
				[setValue]="filterSelected">
			</cpi-input-with-autocomplete>

			<div class="main-input-field-container" *ngIf="selectedField === 'Select'">
				<select [(ngModel)]="selectedOption">
					<option value="" disabled>{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let opt of filteredOptions" [value]="opt.id">
						{{ opt.value_item }}
					</option>
				</select>
			</div>

			<div class="main-input-field-container" *ngIf="selectedField === ''">
				<input type="search" disabled [placeholder]="labels.lbl_chamado_campo" />
			</div>

			<div *ngIf="selectedField === ''">
				<fa-icon disabled [icon]="icons.faSearch"></fa-icon>
			</div>

			<div class="main-input-field-container" *ngIf="selectedField === 'Text' || selectedField === 'text'">
				<input type="search" (keydown.enter)="searchRequest()" [(ngModel)]="selectedOption" />
			</div>

			<div class="main-input-field-container" *ngIf="selectedField === 'Date'">
				<input
					type="text"
					[(ngModel)]="selectedOption"
					(click)="isDatePickerOpen = true"
					readonly
					placeholder="Selecione o intervalo de datas" />
				<div class="date-picker-wrapper" *ngIf="isDatePickerOpen">
					<date-range-picker
						*ngIf="isDatePickerOpen"
						[showTime]="false"
						(datesConfirmed)="onDatesConfirmed($event)"
						(calendarClosed)="isDatePickerOpen = false"></date-range-picker>
				</div>
			</div>

			<div class="main-input-field-container" *ngIf="selectedField === 'Boolean'">
				<cpi-checkbox
					[value]="selectedOption"
					(oValue)="selectedOption = $event"
					[innerText]="selectedOption ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>

			<div *ngIf="selectedOption || selectedField === 'Boolean'">
				<div style="cursor: pointer" (click)="searchRequest()" (keydown.enter)="searchRequest()">
					<fa-icon [icon]="icons.faSearch"></fa-icon>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<div class="loading-container" *ngIf="isLoadingAllStatus || isLoadingAvailableAccordions || !labels" #loadingMesoContainer>
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
